import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import b from 'b_';
import PolicySection from '../PolicySection';
import PolicySectionHeader from '../PolicySectionHeader/PolicySectionHeader';
import FileSizeStore from '../../../stores/Policy/FileRules/FileSizeStore';
import { FTBody } from '../../Fuse';
import FuseTextfield from '../../FuseControls/FuseTextfield';
import Pill, { PILL } from '../../Pill/Pill';
import CheckboxContainer from '../../CheckboxContainer/CheckboxContainer';
import FuseReadOnlyCheckbox from '../../FuseControls/FuseReadOnlyCheckbox';
import './FileSize.css';

const block = b.lock('FileSize');

class FileSize extends Component {
    static propTypes = {
        store: FileSizeStore.PropType.isRequired,
        readOnly: PropTypes.bool,
    };

    renderFileSizeField = () => {
        const { readOnly, store } = this.props;
        if (readOnly) {
            return <Pill className={block('Pill')} type={PILL.GRAY}>{store.maxFileSize.value} MB</Pill>;
        }
        return <div className={block('InputContainer')}>
            <FuseTextfield
                store={store.maxFileSize}
                placeholder="Enter Max File Size"
            />
            <FTBody className={block('InputSuffix')}>MB</FTBody>
        </div>;
    }

    render() {
        const { readOnly, store } = this.props;

        return <PolicySection grayBackground={!readOnly} readOnly={readOnly}>
            <PolicySectionHeader
                title="Max File Size"
                tooltipText={'Define a maximum file size. Files that exceed this maximum value will not match the ' +
                    'rules selected action.'}
            />
            {(readOnly && store.matchAllFileSize.isTrue) ?
                <FTBody>All File Sizes</FTBody> :
                <Fragment>
                    {!readOnly ? <CheckboxContainer
                        readOnly={readOnly}
                        matchAll={store.matchAllFileSize.isTrue}
                    >
                        <FuseReadOnlyCheckbox
                            store={store.matchAllFileSize}
                            label="Match All File Sizes"
                            qa="match-all-file-sizes"
                        />
                    </CheckboxContainer> : null}
                    {!store.matchAllFileSize.isTrue ? this.renderFileSizeField() : null }
                </Fragment>}
        </PolicySection>;
    }
}

export default observer(FileSize);
